module.exports = __webpack_public_path__ + "static/media/r_itdot_15.2eb48316.png";